import type {ReactElement} from 'react';
import {CHECKBOX_TYPE, Checkbox} from '@Components/checkbox-legacy';
import {IconSize} from '@Components/icon-v2/icon.types';
import {ClickableDiv} from '@Components/clickable-div';
import {withoutNativeInputClicks} from '@Utils/dom.util';
import type {SelectableOptionRowProps} from './selectable-option-row.types';

export function SelectableOptionRow({
  isChecked,
  onToggle,
  checkboxAriaLabel,
  isDisabled = false,
  className,
  checkboxClasses,
  'data-testid': dataTestId,
  children,
}: SelectableOptionRowProps): ReactElement {
  return (
    <ClickableDiv
      className={className}
      data-testid={dataTestId}
      onClick={withoutNativeInputClicks(onToggle)}
      aria-disabled={isDisabled}
      aria-label={checkboxAriaLabel}
    >
      <Checkbox
        className={checkboxClasses}
        size={IconSize.SIZE_ICON_16}
        isChecked={isChecked}
        disabled={isDisabled}
        type={isChecked ? CHECKBOX_TYPE.PRIMARY : CHECKBOX_TYPE.DEFAULT}
      />
      {children}
    </ClickableDiv>
  );
}
